import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { SuccessIcon, WarningIcon, InfoIcon, PermissionIcon, ShaprLogoIcon } from '../CompositeIcons/CompositeIcons.js';
import style from './InfoPage.module.css.js';

const icons = {
    success: jsx(SuccessIcon, {}),
    warning: jsx(WarningIcon, {}),
    information: jsx(InfoIcon, {}),
    permission: jsx(PermissionIcon, {}),
    default: jsx(ShaprLogoIcon, {}),
};
function StatusIcon({ variant }) {
    return icons[variant ?? "default"];
}
const InfoPage = ({ title, primaryCTA, primaryCTALabel, description, variant, body, footer }) => {
    return (jsx("div", { className: style.pageCenterContainer, children: jsxs("div", { className: style.container, children: [jsxs("div", { className: style.infoPageContainer, children: [jsx(StatusIcon, { variant: variant }), jsxs("div", { children: [jsx("h1", { className: style.title, children: title }), description && jsx("div", { className: style.description, children: description })] }), body && jsx("div", { children: body }), primaryCTA && (jsxs(Fragment, { children: [jsx("div", { className: style.separator }), jsxs("div", { children: [primaryCTALabel && jsx("div", { className: style.ctaLabel, children: primaryCTALabel }), jsx("div", { className: style.ctaContainer, children: primaryCTA })] })] }))] }), footer && jsx("div", { children: footer })] }) }));
};

export { InfoPage };
//# sourceMappingURL=InfoPage.js.map
